module.exports = __webpack_public_path__ + "static/media/mitsl200-1986mh.4513ea89.jpg";